import { render } from "./Discounts.vue?vue&type=template&id=7b81ef6a&scoped=true"
import script from "./Discounts.vue?vue&type=script&lang=js"
export * from "./Discounts.vue?vue&type=script&lang=js"

import "./Discounts.vue?vue&type=style&index=0&id=7b81ef6a&scoped=true&lang=scss"

import exportComponent from "/home/scotty/git/beamy/monolith/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b81ef6a"]])

export default __exports__